import React from 'react';
import GenericModulePage from '../../components/generic/GenericModulePage';
import { initializeModule } from '../../utils/configInit';
import { capaEffectivenessConfig } from './capaEffectivenessConfig';
import { createCapaEffectivenessValidationSchema } from './capaEffectivenessValidation';

const { config: initializedConfig } = initializeModule(
  capaEffectivenessConfig,
  createCapaEffectivenessValidationSchema,
);

const CapaEffectivenessPage = () => {
  return <GenericModulePage config={initializedConfig} />;
};

export default CapaEffectivenessPage;
